import { GetVouchersFilter } from '../../types/hubTypes';
import { createApi } from '../core';
import { Voucher } from '../types/voucher';

export const voucherApi = createApi.group(['voucher'], (createKey) => {
  return {
    all: createApi.query({
      queryKey: createKey(['all']),
      queryFn: (filter?: GetVouchersFilter) => {
        return createApi.fetch({
          path: ['vouchers'],
          method: 'GET',
          query: filter ? { status: filter } : undefined,
          sign: true,
          validator: Voucher.array(),
          basePath: 'portalAPI',
        });
      },
      staleTime: createApi.time(1, 'minutes'),
      refetchInterval: createApi.time(5, 'minutes'),
    }),
  };
});
